var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color-option",class:_vm.selected ? 'selected' : '',style:(("background-color:" + _vm.color)),on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }